export const PARAMETERS = {
  SIZE: 0.05,
  RADIUS: 5,
  BRANCHES: 8,
  SPIN: 0.6,
  RANDOMNESS: 0.3,
  RANDOMNESS_POWER: 3.5,
  INSIDE_COLOR: '#ff6030',
  OUTSIDE_COLOR: '#8269fa',
  COUNT: 70000,
}
